export const permissions = {
    READ: "QUOTATION-READ",
    EDIT: "QUOTATION-EDIT",
    CLONE: "QUOTATION-CLONE",
    DELETE: "QUOTATION-DELETE",
    REGENERATE_INVOICE: 'REGENERATE-INVOICE',
    QUOTATION_APPROVER: "QUOTATION-APPROVER",
    UPLOAD_DOCUMENTS: 'QUOTATION-DOCUMENT-UPLOAD',
    CHANGE_CATEGORY: 'QUOTATION-CHANGE-TRADE-CATEGORY',
}

export const quotation_status = {
    DRAFT: "DRAFT",
    APPROVED: "APPROVED",
    PENDING: "PENDING"
}

export const invoice_status = {
    PAID: 'PAID'
}